import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65cfa466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid message-container-align"
}
const _hoisted_3 = {
  key: 1,
  class: "container-fluid message-container-align"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_10 = { class: "centered-container" }
const _hoisted_11 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_12 = { class: "centered-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer15" }, null, -1))
const _hoisted_14 = {
  id: "previousDownloads",
  class: "txtSize15"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer5" }, null, -1))
const _hoisted_16 = {
  id: "remainingDownloads",
  class: "txtSize15"
}

import { ref, computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import axios from "axios";
import { generateChecksum } from "../services/generateChecksum";
import { decryptData } from "../services/decryptData";
import CryptoJS from "crypto-js";
import { useStore } from "vuex";

const __default__ = {
  name: "PDFDownloadComponent",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const invalidIDFlag = ref(false);
const loader = ref(false);
const route = useRoute();
const store = useStore();
const { t } = useI18n();
const modalVisible = ref(false);
const maxDownloadFlag = ref(false);
const modalMessage = ref("");
const invoiceDetail = ref<any | null>(null);
const maxDownload = computed(() => userDocument?.value?.MaxDownloads);
const downloadCount = computed(() => invoiceDetail?.value?.DownloadCount);
const secretKey = process.env.VUE_APP_ENCRYPT_DECRYPT_SECRET_KEY;
const JwtSecretKey = process.env.VUE_APP_JWT_KEY;
const remainingDownloads = computed(
  () => maxDownload.value - downloadCount.value
);
const userDocument = ref<any | null>(null);
const baseUrl = process.env.VUE_APP_BASE_API_URL;
const errorFlag = ref(false);
const unAuthorizedFlag = ref(false);
const userId = ref(route.query.p as string);
const fileName = computed(() => userDocument?.value?.FileName);
const generateUrl = async () => {
  loader.value = true;
  let token = getTokenFromSessionStorage();

  if (!token) {
    token = await getToken(token);
  }

  try {
    const encryptedDataValue = {
      FolderName: userId.value,
      FileName: fileName.value,
      timestamp: new Date().toISOString(),
    };
    const checksumString = Object.values(encryptedDataValue).join("-");
    const checksum = generateChecksum(checksumString);
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const response = await axios.post(
      `${baseUrl}/url/generate-url`,
      { encryptedDataString },
      { headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum } }
    );
    const encryptedData = response.data;
    const decryptedText = decryptData(encryptedData);
    const invoiceData = JSON.parse(decryptedText);
    const receivedChecksum = response.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(response.data);
    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value
    ) {
      url.value = invoiceData.filePath;
    } else {
      errorFlag.value = true;
      loader.value = false;
    }
    return true;
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    if (error.response) {
      console.error(
        "Error generating URL:",
        error.response?.data?.message || "Unknown error"
      );
      return false;
    } else if (error.request) {
      console.error(
        "No response received. Please check your network connection."
      );
      return false;
    } else {
      console.error("Error in generating URL:", error.message);
      return false;
    }
  }
};
const url = ref("");
const triggerFileDownload = async () => {
  const urlGenerated = await generateUrl();
  if (urlGenerated) {
    if (url.value) {
      const link = document.createElement("a");
      link.href = url.value;
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showModal(t("download.PDFInvoicedownloadedsuccessfully"));
      fetchUserData();
      loader.value = false;
    } else {
      showModal(t("download.PDFdownloadedFailure"));
      console.error("No signed URL available for download.");
    }
  }
};

const getTokenFromSessionStorage = () => {
  const token = sessionStorage.getItem(`token_${userId.value}`);
  const expirationTime = parseInt(
    sessionStorage.getItem(`tokenExpiration_${userId.value}`) || "0"
  );

  if (Date.now() > expirationTime) {
    sessionStorage.removeItem(`token_${userId.value}`);
    sessionStorage.removeItem(`tokenExpiration_${userId.value}`);
    return null;
  }
  return token;
};

const showModal = (message: string) => {
  modalMessage.value = message;
  modalVisible.value = true;
};
const setTokenInSessionStorage = (token: any, expiresIn: number) => {
  const expirationTime = Date.now() + expiresIn * 3600 * 1000;
  sessionStorage.setItem(`token_${userId.value}`, token);
  sessionStorage.setItem(
    `tokenExpiration_${userId.value}`,
    expirationTime.toString()
  );
};
const getInvoiceCount = async (token: any) => {
  loader.value = true;
  const checksumString = `${userId.value}`;
  const checksum = generateChecksum(checksumString);
  try {
    const invoiceCountDetail = await axios.get(
      `${baseUrl}/invoice/count/${userId.value}`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
      }
    );
    const encryptedData = invoiceCountDetail.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = invoiceCountDetail.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(invoiceCountDetail.data);
    const invoiceData = JSON.parse(decryptedText);
    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value
    ) {
      invoiceDetail.value = invoiceData;
      loader.value = false;
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    console.error("Failed to fetch invoice details:", error);
  }
};
const getToken = async (token: any) => {
  token = "";
  try {
    const encryptedDataValue = {
      UserId: userId.value,
      SecretKey: JwtSecretKey,
      timestamp: new Date().toISOString(),
    };
    const checksumString = Object.values(encryptedDataValue).join("-");
    const checksum = generateChecksum(checksumString);
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const tokenResponse = await axios.post(
      `${baseUrl}/auth/generate-token`,
      { encryptedDataString },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Checksum": checksum,
        },
      }
    );
    token = tokenResponse.data.token;
    setTokenInSessionStorage(token, 23);
    return token;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 404 || error.response.status === 401) {
        unAuthorizedFlag.value = true;
      }
    }
    errorFlag.value = true;
    throw new Error("Failed to generate token. Please try again.");
  }
};
const fetchUserData = async () => {
  try {
    loader.value = true;
    let token = getTokenFromSessionStorage();

    if (!token) {
      token = await getToken(token);
    }
    const checksumString = `${userId.value}`;
    const checksum = generateChecksum(checksumString);
    try {
      const invoiceResponse = await axios.get(
        `${baseUrl}/invoice/${userId.value}`,
        {
          headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
        }
      );
      const encryptedData = invoiceResponse.data;
      const decryptedText = decryptData(encryptedData);
      const receivedChecksum = invoiceResponse.headers["x-file-checksum"];
      const calculatedChecksum = generateChecksum(invoiceResponse.data);
      const invoiceData = JSON.parse(decryptedText);

      if (
        receivedChecksum === calculatedChecksum &&
        invoiceData.UserId === userId.value
      ) {
        userDocument.value = invoiceData;
        loader.value = false;
      } else {
        loader.value = false;
        errorFlag.value = true;
      }
    } catch (error: any) {
      console.error("Failed to fetch user data", error);
      if (error.response && error.response.status === 404) {
        throw new Error(
          "User ID not found. Please check the ID and try again."
        );
      } else {
        errorFlag.value = true;
        throw new Error("Failed to fetch user data. Please try again later.");
      }
    }
    getInvoiceCount(token);
  } catch (error: any) {
    error.value =
      error.message || "An unexpected error occurred. Please try again later.";
    loader.value = false;
  }
};
onMounted(() => {
  if (store.state.isAuth) {
    fetchUserData();
  } else {
    loader.value = false;
    invalidIDFlag.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_navbar, {
      toggleable: "",
      type: "light",
      variant: "light",
      class: "p-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_navbar_brand, { class: "title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("titleInvoice")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_b_spinner, {
            style: {"width":"6rem","height":"6rem","color":"#003778"},
            label: "Large Spinner"
          })
        ]))
      : _createCommentVNode("", true),
    (errorFlag.value || invalidIDFlag.value || unAuthorizedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)("form.unauthorized")), 1))
            : _createCommentVNode("", true),
          (errorFlag.value && !unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_unref(t)("form.unabletoprocesstherequest")), 1))
            : _createCommentVNode("", true),
          (invalidIDFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_unref(t)("form.invalidrequest")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_b_modal, {
      modelValue: modalVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalVisible).value = $event)),
      title: _unref(t)('download.downloadstatus'),
      "ok-title": _unref(t)('download.ok'),
      "cancel-title": _unref(t)('download.cancel')
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_7, _toDisplayString(modalMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title", "ok-title", "cancel-title"]),
    (!loader.value && !errorFlag.value && !invalidIDFlag.value && !unAuthorizedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (maxDownloadFlag.value || remainingDownloads.value <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("download.maxDownloadsExceeded")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!maxDownloadFlag.value && remainingDownloads.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_b_button, {
                    pill: "",
                    class: "custom-button",
                    onClick: triggerFileDownload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("download.download")), 1)
                    ]),
                    _: 1
                  }),
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("download.previousdownloads")) + ": " + _toDisplayString(downloadCount.value), 1),
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("download.remainingdownloads")) + ": " + _toDisplayString(remainingDownloads.value), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})